import {all} from 'redux-saga/effects';
import authSaga from './authSaga';
import superAdminDashboardSaga from './superAdminDashboardSaga';
import patientDashboardSaga from './patientDashboardSaga';
import appSettingsSaga from './appSettingSaga';
import specialistDashboardSaga from './specialistDashboardSaga';
import chatSaga from './chatSaga';
import patientAdminSaga from './patientAdminSaga';
import hospitalAdminSaga from './hospitalAdminSaga';
import supportAdminSaga from './supportAdminSaga';
import specialistAdminSaga from './specialistAdminSaga';
import financeAdminSaga from './financeAdminSaga';
import notificationSaga from './notificationSaga';

const rootSaga = function* root() {
  yield all([
    authSaga(),
    superAdminDashboardSaga(),
    patientDashboardSaga(),
    appSettingsSaga(),
    specialistDashboardSaga(),
    chatSaga(),
    patientAdminSaga(),
    hospitalAdminSaga(),
    supportAdminSaga(),
    specialistAdminSaga(),
    financeAdminSaga(),
    notificationSaga(),
  ]);
};

export default rootSaga;
